import CommonComponents from '@/components/templates/common'
import { useTemplateContext } from '@/context/TemplateProvider'
import Header from '@/templates/header'

import Layout from './spa.views'

const SpaHero = () => {
  const { template } = useTemplateContext()

  return (
    <Layout className='select-none pointer-events-none'>
      <Layout.Hero
        backgroundImage={template.sections.hero.backgroundImage}
        afterBackgroundColor='complementary'
        afterBackgroundColorOpacity='0.5'
        textColor="complementary"
      >
        <Header transparent />
        <Layout.HeroContainer>
          <CommonComponents.Wrapper>
            <Layout.TitleContainer>
              <Layout.Title textColor="primary" fontFamily={template.theme.typography.fontFamily}>{template.sections.hero.title}</Layout.Title>
              <Layout.Subtitle textColor="textPrimary" fontFamily={template.theme.typography.secondaryFont.fontFamily}>
                {template.sections.hero.subtitle}
              </Layout.Subtitle>
              <Layout.CTA
                textColor='complementary'
                backgroundColor="primary"
                fontFamily={template.theme.typography.secondaryFont.fontFamily}
              >
                {template.sections.hero.ctaText}
              </Layout.CTA>
            </Layout.TitleContainer>
          </CommonComponents.Wrapper>
        </Layout.HeroContainer>
      </Layout.Hero>
    </Layout>
  )
}

export default SpaHero
